<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>雁南时空科技</h3>
          <p class="company-desc">公司作为大疆行业级无人机官方授权合作伙伴，专注于为政企客户提供涵盖无人机系统集成、定制化软件开发与低空运营服务的全方位解决方案</p>
          <div class="social-links">
          <a href="/contact" class="social-link" title="社交账号"><i class="el-icon-chat-dot-round"></i></a>
          <a href="/contact" class="social-link" title="联系我们"><i class="el-icon-chat-line-round"></i></a>
          <a href="/contact" class="social-link" title="客服电话"><i class="el-icon-phone-outline"></i></a>
          </div>
        </div>
        <div class="footer-section">
          <h4>业务板块</h4>
          <ul>
            <li><router-link to="/business">无人机销售</router-link></li>
            <li><router-link to="/business">软件平台开发</router-link></li>
            <li><router-link to="/business">低空数据运营</router-link></li>
            <li><router-link to="/business">实景三维建模</router-link></li>
          </ul>
        </div>
        <div class="footer-section">
          <h4>关于我们</h4>
          <ul>
            <li><router-link to="/about">公司简介</router-link></li>
            <li><router-link to="/cases">成功案例</router-link></li>
            <li><router-link to="/news">新闻动态</router-link></li>
            <li><router-link to="/contact">联系我们</router-link></li>
          </ul>
        </div>
        <div class="footer-section">
          <h4>联系方式</h4>
          <ul class="contact-info">
            <li><i class="el-icon-location"></i> 地址：两江新区财富中心财富E座606号</li>
            <li><i class="el-icon-phone"></i> 电话：18723212667</li>
            <li><i class="el-icon-message"></i> 邮箱：待填写</li>
            <li><i class="el-icon-time"></i> 工作时间：周一至周五 9:00-18:00</li>
          </ul>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; 2026 雁南时空科技（重庆）有限公司 版权所有</p>
        <p class="icp-info">
          <a href="http://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">渝ICP备2024021973号</a>
          <span class="icp-separator">|</span>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50019002505333" target="_blank" rel="noopener noreferrer">渝公网安备50019002505333号</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped lang="scss">
.footer {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: #fff;
  padding: 60px 0 20px;

  .footer-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 40px;
    margin-bottom: 40px;

    .footer-section {
      h3 {
        font-size: 24px;
        margin-bottom: 20px;
        background: linear-gradient(135deg, #1890ff, #52c41a);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      h4 {
        font-size: 18px;
        margin-bottom: 20px;
        color: #fff;
      }

      .company-desc {
        color: #ccc;
        line-height: 1.8;
        margin-bottom: 20px;
      }

      ul {
        list-style: none;

        li {
          margin-bottom: 12px;

          a {
            color: #ccc;
            text-decoration: none;
            transition: color 0.3s;

            &:hover {
              color: #1890ff;
            }
          }

          i {
            margin-right: 8px;
            color: #1890ff;
          }
        }
      }

      .social-links {
        display: flex;
        gap: 15px;
        margin-top: 20px;

        .social-link {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 18px;
          transition: all 0.3s;

          &:hover {
            background: #1890ff;
            transform: translateY(-3px);
          }
        }
      }

      .contact-info {
        li {
          color: #ccc;
          line-height: 1.8;
          white-space: nowrap;
        }
      }
    }
  }

  .footer-bottom {
    text-align: center;
    padding-top: 30px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);

    p {
      color: #999;
      font-size: 14px;
      margin-bottom: 8px;
    }

    .icp-info {
      font-size: 14px;
      color: #999;

      a {
        color: #999;
        text-decoration: none;
        transition: color 0.3s;

        &:hover {
          color: #1890ff;
        }
      }

      .icp-separator {
        margin: 0 8px;
        color: #666;
      }
    }
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 40px 0 20px;

    .footer-content {
      grid-template-columns: 1fr;
      gap: 30px;
    }
  }
}
</style>

